import { Actions } from '@/features/actions';
import { Editor } from '@/features/editor/ui/editor/editor';
import { Price } from '@/features/price';
import { SectionsInfo } from '@/features/sections-info';
import { Title } from '@/features/title';
import { Toolbar } from '@/features/toolbar';
import { ConfiguratorDataProvider } from '../../context/configurator-data/configurator-data.provider';
import { useData } from '../../hooks/useData';
import styles from './configurator.module.css';

export const Configurator = () => {
	const { isLoading, isError, data } = useData();

	if (isLoading) {
		return (
			<div className={styles.messageWrapper}>
				<div className={styles.loader} />
			</div>
		);
	}

	if (isError || !data) {
		return (
			<div className={styles.messageWrapper}>
				<div className={styles.error}>Failed to load configurator</div>
			</div>
		);
	}

	return (
		<ConfiguratorDataProvider data={data}>
			<div className={styles.wrapper}>
				<div className={styles.configurator}>
					<Toolbar />
					<Editor />
					<Actions />
					<Title />
					<Price />
					<SectionsInfo />
				</div>
			</div>
		</ConfiguratorDataProvider>
	);
};
